import { Button, Modal, notification } from 'antd';
import React, { useRef, useState } from 'react';

import { ICurrency } from 'src/apis/common';
import { IInvoice } from 'src/apis/Reporting/ChargeHistory';
import { issueRefund } from 'src/apis/Reporting/Refund';
import RefundForm, { IProps as IFormProps, buildInvoiceItemRefundRequests } from './RefundForm';
import styles from './RefundModal.module.css';

export interface IProps {
    companyName: string;
    currency: ICurrency;
    customerID: number;
    invoice: IInvoice;

    // We fire this callback when the modal should be closed.
    requestClose: () => void;
}

const RefundModal: React.FC<IProps> = (props) => {
    const [submitting, setSubmitting] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');

    // I have no idea what type to put in place of <any> here.
    const formRef = useRef<any>(null);

    const handleClose = (e: React.MouseEvent) => {
        e.preventDefault();
        props.requestClose();
    };
    const handleSubmit = () => {
        const { customerID, invoice } = props;

        // per <https://3x.ant.design/components/form/#components-form-demo-form-in-modal>
        const formProps: IFormProps = formRef.current!.props;
        const { form } = formProps;
        form.validateFields(async (err, values) => {
            if (err) {
                return;
            }
            setSubmitting(true);
            const invoiceItemRefundRequests = buildInvoiceItemRefundRequests(values);
            try {
                const response = await issueRefund(customerID, invoice.id, invoiceItemRefundRequests, values.note);
                setResponseMessage(response.message);
                if (response.success) {
                    // Reload the whole page to update state!
                    window.location.reload();
                }
            } catch (e) {
                setResponseMessage('Error refunding the transaction. Please report this issue.');
            }
            setSubmitting(false);
        });
    };

    return (
      <Modal
        closable={false}
        title={`Refund Transaction to ${props.companyName} `}
        visible={true}
        footer={[
            <div key="footerContainer" className={styles.footerContainer}>
                <Button key="close" onClick={handleClose}>Cancel</Button>
                <Button type='primary' loading={submitting} onClick={handleSubmit}>Submit</Button>
            </div>
        ]}
      >
          <RefundForm currency={props.currency} invoice={props.invoice} wrappedComponentRef={formRef} />
          <span className={styles.errorMessage}>{responseMessage}</span>
      </Modal>
    );
}

export default RefundModal;
